<template>
	<div class="qcode" v-if="isShowQcode">
		<div class="qcode-div">
			<span class="qcode-text">长按二维码，关注微信公众号</span>
			<span class="qcode-text">方便下次阅读</span>
			<img  class="qcode-image" :src="qcodeUrl"  alt="">
			<span  class="qcode-text" @click="changeStatus">关闭</span>
		</div>
	</div>
</template>
<script>
	export default{
		props:{
			qcodeUrl:{
				type:String,
				default:''
			},
			isShowQcode:{
				type:Boolean,
				default:false
				}
		},
		watch:{
			
		},
		data(){
			return{
			}
		},
		mounted() {
			
		},
		methods:{
			changeStatus(){
				this.$emit('eventChange',false)
				
			}
		}
	}
</script>

<style scoped>
	.qcode{
		position: fixed;
		left: 0px;
		top: 0px;
		background-color: rgba(0,0,0,.5);
		width: 100%;
		height: 100%;
		z-index:10000;
	}
	.qcode-div{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%);
		background-color: #FFFFFF;
		width: 242px;
		height:300px;
		border-radius: 10px;
		padding: 24px 23px;
		text-align: center;
		box-sizing: border-box;
	}
	.qcode>.qcode-div>.qcode-text:nth-child(1){
		font-size: 15px;
		color: #333333;
		display: block;
		font-weight: bold;
	}
	.qcode>.qcode-div>.qcode-text:nth-child(2){
		font-size: 14px;
		color: #DE3B34;
		margin-top: 4px;
		margin-bottom:16px;
		display: block;
	}
	.qcode>.qcode-div>.qcode-image{
		width: 150px;
		height: 150px;
	}
	.qcode>.qcode-div>.qcode-text:nth-child(4){
		display: block;
		padding-top: 10px;
		font-size: 14px;
		color: #333333;
		border-top: 1px solid #F3F3F3;
		margin-top:20px;
	}
</style>



// WEBPACK FOOTER //
// src/view/bookRead/component/qcode.vue